export { default as App } from './App/App'
export { default as Home } from './Home/Home'
export { default as Fund } from './Fund/Fund'
export { default as FundRedirect } from './FundRedirect/FundRedirect'
export { default as List } from './List/List'
export { default as Compare } from './Compare/Compare'
export { default as NotFound } from './NotFound/NotFound'
export { default as Family } from './Family/Family'
export { default as About } from './About/About'
export { default as HowItWorks } from './HowItWorks/HowItWorks'
export { default as FAQ } from './FAQ/FAQ'
export { default as Media } from './Media/Media'
export { default as Legal } from './Legal/Legal'
export { default as Companies } from './Companies/Companies'
export { default as Toolkit } from './Toolkit/Toolkit'
export { default as IndexFunds } from './IndexFunds/IndexFunds'
export { default as TargetDateSeries } from './TargetDateSeries/TargetDateSeries'
export { default as Petitions } from './Petitions/Petitions'
